import React from "react";

// پیشخوان
export const LazyCounter = React.lazy(
  () => import("../../features/counter/presentation/pages/index")
);

// ****************** اطلاعات سازمان
// زمین های کشاورز
export const LazyFarmerFields = React.lazy(
  () => import("../../feature/farmer_fields")
);

// export const LazyFarmerFields = React.lazy(() => import("../../features/farm/presentation/pages/index"));

// شناسنامه زمین
export const LazyFieldCertificate = React.lazy(
  () => import("../../feature/field_certificate/index")
);

// نقشه زمین
export const LazeMapPolygonView = React.lazy(
  () => import("../../feature/farmer_fields/components/MapPolygonView")
);

// منبع آبی
export const LazyWaterSources = React.lazy(
  () => import("../../feature/my_water_sources/index")
);

// شناسنامه آب
export const LazyWaterCertificate = React.lazy(
  () => import("../../features/water-certificate/index")
);

// ایستگاه های هواشناسی کشاورز
export const LazyWeatherStation = React.lazy(
  () => import("../../feature/weather_station")
);

//مکانیزاسیون من
export const LazyMyMechanization = React.lazy(
  () => import("../../features/my-mechanization/presentation/pages/index")
);

export const LazyMechanizationCertification = React.lazy(
  () => import("../../features/my-mechanization/presentation/pages/MechanizationCertification")
);

export const LazyMechanizationIotPanel = React.lazy(
  () => import("../../features/iot-panel/presentation/pages/Mechanization")
);

export const LazyWaterSourceIotPanel = React.lazy(
  () => import("../../features/iot-panel/presentation/pages/IrrigationSource")
);

export const LazyIotPanelMap = React.lazy(
  () => import("../../features/iot-panel/presentation/components/map/LiveMap")
);

// صفحه ایستگاه هواشناسی
export const LazyWeatherStationPage = React.lazy(
  () => import("../../feature/weather_station/Station")
);

// ****************** نرم افزارهای آسیب شناسی
// بازدیدها و نظارت
export const LazyVisits = React.lazy(
  () => import("../../features/Visit/presentation/pages")
);

// گزارشات بازدید
export const LazyVisitReports = React.lazy(
  () => import("../../features/Visit/presentation/pages/VisitReports")
);

// آزمایشگاه
export const LazyLaboratory = React.lazy(
  () => import("../../features/laboratory/presentation/pages/index")
);

// گزارشات آزمایشگاه
export const LazyLaboratoryReports = React.lazy(
  () => import("../../features/laboratory/presentation/pages/LaboratoryReports")
);

// عملیات
export const LazyOperations = React.lazy(
  () => import("../../features/operations/presentation/pages")
);

// ****************** نرم افزارهای برنامه ریزی
// برنامه کودی ها
export const LazyNutritionProgram = React.lazy(
  () => import("../../features/nutrition-program/presentation/pages/index")
);

// نیاز سرمایی
export const LazyChillingRequirements = React.lazy(
  () => import("../../features/chilling-requirement/presentation/pages")
);

// ارقام
export const LazyCultivarRecommendation = React.lazy(
  () =>
    import("../../features/cultivar-recommendation/presentation/pages/index")
);

// تاریخ برداشت
export const LazyHarvestDate = React.lazy(
  () => import("../../features/harvest-date/presentation/pages")
);

// خلا عملکرد
export const LazyYieldGaps = React.lazy(
  () => import("../../features/yield-gaps/presentation/pages")
);

// تاریخ کاشت
export const LazySowingDates = React.lazy(
  () => import("../../features/sowing-date/presentation/pages/index")
);

// علف هرز
export const LazyWeedManagement = React.lazy(
  () => import("../../features/weedless/presentation/pages/index")
);

// الگوی کشت
export const LazyCroppingPattern = React.lazy(
  () => import("../../features/cropping-pattern/presentation/pages/index")
);

// تناسب کشت
export const LazyCroppingSuitability = React.lazy(
  () => import("../../features/cropping-suitability/presentation/pages/index")
);

// آبیاری اول زعفران
export const LazyFirstSaffronIrrigation = React.lazy(
  () =>
    import("../../features/first-saffron-irrigation/presentation/pages/index")
);

// ****************** بازار کشاورزی
export const LazyAgriculturalMarket = React.lazy(
  () => import("../../features/agricultural-market/presentation/pages")
);

export const LazyAgriculturalInputInquiry = React.lazy(
  () => import("../../features/agricultural-market/agricultural-input-purchasing/presentation/pages/Inquiry")
);

export const LazyAgriculturalInputOrder = React.lazy(
  () => import("../../features/agricultural-market/agricultural-input-purchasing/presentation/pages/AgriculturalInputOrderRegistration")
);

// ****************** شبکه کشاورزان پیشرو
export const LazyMeeto = React.lazy(
  () => import("../../features/agromeet/presentation/pages/index")
);

// ****************** شبکه کشاورزان پیشرو
export const LazyFarmacounting = React.lazy(
  () => import("../../features/farmacounting/presentation/pages/index")
);

// ****************** مدیریت داشبورد
// افزایش موجودی
export const Lazyincreasebalance = React.lazy(
  () =>
    import(
      "../../features/financial-management/presentation/components/wallet/ChargeWallet"
    )
);

// مدیریت مالی
export const LazyFinancial = React.lazy(
  () => import("../../features/financial-management/presentation/pages/index")
);

// پرداخت
export const LazyWalletPayment = React.lazy(
  () => import("../../features/payment/wallet/presentation/pages/index")
);

export const LazyAgriculturalInputPurchasingPayment = React.lazy(
  () => import("../../features/payment/agricultural-market/presentation/pages/index")
);

// کارشناسان
export const LazyExperts = React.lazy(
  () => import("../../features/my-colleagues/presentation/pages/index")
);

// تغییر کشاورز (کارشناس دارای دسترسی به چند کشاورز)
export const LazyFarmerSwitchForExpert = React.lazy(
  () => import("../../feature/farmer_experts/farmerSelectPage/FarmerSwitchPage")
);

// پروفایل کاربری
export const LazyFarmerProfile = React.lazy(
  () => import("../../features/farmer-profile/presentation/pages/index")
)

// مشاهده و تغییر دسترسی همکار
export const LazyColleagueAccessConfigs = React.lazy(
  () =>
    import(
      "../../features/my-colleagues/presentation/pages/colleague-access/ManageColleagueAccessConfigs"
    )
);
